<template>
	<div class="Editorial">
		<div class="container">
			<h1>{{ $t('navigationEditorial.title') }}</h1>
			<div class="row align-items-center">
				<div class="Editorial__BlogPosts py-5">
					<div class="mb-3">
						{{ $t('navigationEditorial.subtitle') }}
					</div>

					<div class="EditorialPreviewSpace">
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial1' }">
								<h2>
									{{ $t('navigationEditorial.editorial1.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialKampfsportVsSelbsterhaltungThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialKampfsportVsSelbsterhaltungThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialKampfsportVsSelbsterhaltungThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialKampfsportVsSelbsterhaltungThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial1.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial2' }">
								<h2>
									{{ $t('navigationEditorial.editorial2.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialDerVergesseneUrsprungThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialDerVergesseneUrsprungThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialDerVergesseneUrsprungThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialDerVergesseneUrsprungThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial2.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial3' }">
								<h2>
									{{ $t('navigationEditorial.editorial3.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialLebenInDerGegenwartThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialLebenInDerGegenwartThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialLebenInDerGegenwartThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialLebenInDerGegenwartThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial3.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial4' }">
								<h2>
									{{ $t('navigationEditorial.editorial4.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialBallastVergangenheitThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialBallastVergangenheitThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialBallastVergangenheitThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialBallastVergangenheitThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial4.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial5' }">
								<h2>
									{{ $t('navigationEditorial.editorial5.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialMaximeThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialMaximeThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialMaximeThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialMaximeThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial5.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial6' }">
								<h2>
									{{ $t('navigationEditorial.editorial6.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialScienceThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialScienceThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialScienceThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialScienceThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial6.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial7' }">
								<h2>
									{{ $t('navigationEditorial.editorial7.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialSpiritualiaetThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialSpiritualiaetThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialSpiritualiaetThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialSpiritualiaetThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial7.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial8' }">
								<h2>
									{{ $t('navigationEditorial.editorial8.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialAsphaltThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialAsphaltThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialAsphaltThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialAsphaltThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial8.vorschau') }}..
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
						<div class="EditorialPreview">
							<router-link :to="{ name: 'Editorial9' }">
								<h2>
									{{ $t('navigationEditorial.editorial9.title') }}
								</h2>
								<img
									src="@/assets/editorial/EditorialLeitbildThumbnail.jpg"
									srcset="
										@/assets/editorial/EditorialLeitbildThumbnail-400.jpg  400w,
										@/assets/editorial/EditorialLeitbildThumbnail-768.jpg  768w,
										@/assets/editorial/EditorialLeitbildThumbnail.jpg     1000w
									"
									sizes="(max-width: 300px) 100vw, (max-width: 768px) 76vw, (max-width: 991px) 70vw, (max-width: 1028px) 37vw, (max-width: 1120px) 35vw, (max-width: 1200px) 31vw, (max-width: 1330px) 34vw, (max-width: 1480px) 31vw, (max-width: 1600px) 29vw, (max-width: 1850px) 24vw, (max-width: 1950px) 23vw, (max-width: 2050px) 22vw, (max-width: 2300px) 20vw, (max-width: 2550px) 18vw, 17vw"
								/>
								<div class="mb-5">
									{{ $t('navigationEditorial.editorial9.vorschau') }}...
								</div>
								<div class="EditorialPreview__ReadMore">
									{{ $t('navigationEditorial.button.readMore') }}
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import editorialMixin from '@/views/editorial/editorialMixin.js'

export default {
	name: 'Editorial',
	mixins: [editorialMixin]
}
</script>

<style lang="stylus">
.EditorialPreviewSpace {
	display: flex;
	flex-wrap: wrap;
}

.EditorialPreview {
	margin: 15px;
	border: 1px rgba(255,255,255,0.6) solid;
    padding: 25px;
	transition: transform .2s;
	width: 45%;
	background-color: rgba(11,38,46,0.8);
	position: relative;
}

.EditorialPreview img {
	margin-bottom: 25px;
}

@media only screen and (max-width: 991px) {
	.EditorialPreview {
		width: 100%;
	}
}
@media only screen and (max-width: 300px) {
	.EditorialPreview {
		width: 90%;
	}
}

.EditorialPreview a {
	color: #fff;
}

.EditorialPreview:hover a {
	text-decoration: none;
}

.EditorialPreview:hover {
    transform: scale(1.04);
}

.EditorialPreview__ReadMore {
	border: rgba(255,255,255,0.6) 1px solid;
	padding: 10px;
	text-transform: uppercase;
	transition: transform .2s;
	cursor: pointer;
	position: absolute;
	bottom: 25px;
	right: 25px;
}
</style>
